import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

// Constants
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../constants/typography';

import { pickIf } from '../../../utils/pickIf';

export const useStyles = makeStyles()(
  (theme, { view, isKiteUser, unavailableLabel } = {}) => {
    const color = pickIf(
      unavailableLabel,
      colors.gilead.primary1,
      pickIf(isKiteUser, theme.palette.primary1, theme.palette.primary2),
    );

    return {
      countDescription: {
        color: theme.palette.darkGrey,
        display: 'flex',
        flexDirection: 'column',
        gap: pickIf(view === 'grid', 6, 3),
        fontSize: 14,
        fontWeight: pickIf(isKiteUser, FONT_WEIGHT_BOLD, FONT_WEIGHT_SEMIBOLD),
        [theme.breakpoints.down('lg')]: {
          width: 195,
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            width: 195,
          }),
        },
      },
      countDescriptionValue: {
        fontWeight: pickIf(
          isKiteUser,
          FONT_WEIGHT_REGULAR,
          FONT_WEIGHT_SEMIBOLD,
        ),
      },
      stockItem: {
        color,
        fontSize: 16,
        fontWeight: 600,
        marginLeft: pickIf(
          view === 'grid',
          `${theme.spacing(4)} !important`,
          0,
        ),
        [theme.breakpoints.down('xl')]: {
          marginLeft: pickIf(
            view === 'grid',
            `${theme.spacing(1.5)} !important`,
            0,
          ),
        },
        [theme.breakpoints.down('lg')]: {
          marginLeft: `0 !important`,
        },
        [theme.breakpoints.down('md')]: {
          fontSize: 12,
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: 10,
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            marginLeft: `0 !important`,
          }),
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...(theme.isMobileDevice && {
            fontSize: 12,
          }),
        },
        [theme.breakpoints.downLandscape('sm')]: {
          ...(theme.isMobileDevice && {
            fontSize: 10,
          }),
        },
      },
    };
  },
);
